import { CourseSchedule } from "src/app/models/course-schedule";

export class CourseMapper {

  public static map(c: any[]): CourseSchedule[] {
    let courses: CourseSchedule[] = []
    c.forEach(x => {
      courses.push(new CourseSchedule(x.CourseId, x.Name, x.NameFr,
        x.Cost, x.TrainingProviderName, x.TrainingTypeName, x.TrainingTypeNameFr,
        x.InstructorName, x.PostalCode, x.AddressLine,
        x.AptSuiteUnit, x.PoBox, x.CityTown, x.Province, x.Country,
        x.Capacity, x.SeatsRegistered, x.Classes, x.ElectronicAddresses, x.CourseInstructors,
        x.Language, x.Status, x.StatusLastUpdateDate, x.SeatsConfirmed, x.UnreadNotifications, x.CustomCourseName,
        x.CompletedRegistrations, x.PendingEnrolmentsCount, x.FirstClassDate))
    })
    return courses
  }
}
